import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { DashboardSubNav } from "@/components/AdSlot";
import { Plus, Megaphone } from "lucide-react";

const STATUS = {
  draft: { label: "Draft", cls: "bg-muted text-foreground/70" },
  pending_payment: { label: "Awaiting payment", cls: "bg-accent/15 text-accent-dark" },
  active: { label: "Active", cls: "bg-success/15 text-success" },
  ended: { label: "Ended", cls: "bg-muted text-muted-foreground" },
  removed: { label: "Removed", cls: "bg-destructive/10 text-destructive" },
};

export default function MyAdsPage() {
  const [ads, setAds] = useState(null);

  useEffect(() => {
    api.get("/ads/me").then((r) => setAds(r.data.results)).catch(() => setAds([]));
  }, []);

  return (
    <div className="container-page py-12" data-testid="my-ads-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="chip"><Megaphone className="h-3 w-3" /> Advertise</span>
          <h1 className="mt-3 font-display text-4xl font-bold text-primary lg:text-5xl">My ads</h1>
          <p className="mt-2 text-foreground/70">Promote your practice across the directory.</p>
        </div>
        <Link to="/dashboard/ads/new" className="btn-accent" data-testid="new-ad-btn">
          <Plus className="h-4 w-4" /> Create ad
        </Link>
      </div>
      <DashboardSubNav active="ads" />

      {ads === null ? (
        <p className="mt-8 text-muted-foreground">Loading…</p>
      ) : ads.length === 0 ? (
        <div className="card-surface mt-8 p-10 text-center" data-testid="ads-empty">
          <p className="font-medium text-foreground/80">No ads yet.</p>
          <p className="mt-2 text-sm text-muted-foreground">Promote your practice on the home page or category pages — Basic from $25.</p>
          <Link to="/dashboard/ads/new" className="btn-primary mt-6 inline-flex">Create your first ad</Link>
        </div>
      ) : (
        <div className="mt-8 grid gap-4">
          {ads.map((a) => {
            const s = STATUS[a.status] || { label: a.status, cls: "bg-muted" };
            return (
              <Link key={a.id} to={`/dashboard/ads/${a.id}`} className="card-surface card-hover flex flex-wrap items-center gap-4 p-5" data-testid={`ad-row-${a.id}`}>
                <div className="h-16 w-24 overflow-hidden rounded-md bg-muted">
                  {a.image_url && (
                    <img
                      src={a.image_url.startsWith("http") ? a.image_url : `${process.env.REACT_APP_BACKEND_URL}${a.image_url}`}
                      alt=""
                      className="h-full w-full object-cover"
                    />
                  )}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-display text-lg font-bold text-primary">{a.headline}</h3>
                    <span className={`rounded-full px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${s.cls}`} data-testid={`ad-status-${a.id}`}>{s.label}</span>
                  </div>
                  <p className="mt-1 text-sm text-muted-foreground">
                    {a.placement} · {a.budget_tier} · ${(a.budget_cents / 100).toFixed(0)} · {new Date(a.start_at).toLocaleDateString()} → {new Date(a.end_at).toLocaleDateString()}
                  </p>
                </div>
                <div className="text-right text-xs text-muted-foreground">
                  {a.impressions || 0} impressions · {a.clicks || 0} clicks
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
